//v5化完了

import React from "react"
import { Link } from "gatsby"
import { useTheme } from '@mui/material/styles';
import { StaticImage } from "gatsby-plugin-image"

//mui(v5)
import { Tooltip, Box, AppBar, Grid, IconButton, Toolbar, Menu, MenuItem, Button } from '@mui/material'

//アイコンv5
import HomeIcon from '@mui/icons-material/Home';
import LocalOfferIcon from '@mui/icons-material/LocalOffer'; //タグアイコン
import InfoIcon from '@mui/icons-material/Info';
import MenuIcon from '@mui/icons-material/Menu';

//コンポーネント
import ClientOnly from './ClientOnly'

//検索窓遅延読み込み
// const Search = React.lazy(() => import('./GoogleCustomSearch'))
import Search from './GoogleCustomSearch'

const Header = (({ setMobileOpen, mobileOpen }) => {
    const theme = useTheme()
    const rootPath = `${__PATH_PREFIX__}/`

    //ドロワの出し入れ用：stateはLayout
    const handleDrawerToggle = () => {
        setMobileOpen(() => (!mobileOpen));
    };

    //タグメニューのオープンハンドル
    const [anchorEl, setAnchorEl] = React.useState(null);
    const tagHandleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const tagHandleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box sx={{ display: 'flex', }}>
            <AppBar position="fixed"
                sx={{
                    zIndex: theme.zIndex.drawer + 1,
                }}>
                <Toolbar>
                    <Grid
                        container
                        alignItems="center"
                    >
                        {/* ドロワオープンアイコンとタイトル */}
                        <Grid item>
                            <Grid container
                                sx={{
                                    [theme.breakpoints.up('lg')]: { paddingRight: theme.spacing(10) }
                                }}
                            >
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    edge="start"
                                    onClick={handleDrawerToggle}
                                    sx={{
                                        marginRight: theme.spacing(2),
                                        marginLeft: theme.spacing(0),
                                    }}
                                >
                                    <MenuIcon />
                                </IconButton>
                                <Grid item>
                                    <Button variant="contained" disableElevation size="large" component={Link} to={rootPath}
                                        sx={{
                                            width: "150px",
                                        }}
                                    >
                                        {/* タイトル */}
                                        <StaticImage src="../images/logo_small.png" placeholder="blurred" alt="謎の技術研究部" />

                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* ヘッダ ナビゲーション */}
                        <Grid item sx={{
                            [theme.breakpoints.down('lg')]: { display: "none" }
                        }}>
                            <Grid container spacing={3}>
                                <Grid item>
                                    <Button variant="contained" disableElevation
                                        component={Link} to={rootPath}
                                        startIcon={<HomeIcon />}>ホーム</Button>
                                </Grid>
                                <Grid item>
                                    {/* ./にしてしまうと相対になるのでエラー。ルートからは/～で始める */}
                                    {/* <Button component={Link} to={"/tags"} startIcon={<LocalOfferIcon />}>タグ</Button> */}
                                    <Button variant="contained" disableElevation startIcon={<LocalOfferIcon />} aria-controls="simple-menu" aria-haspopup="true" onClick={tagHandleClick}>タグ</Button>
                                    <Menu
                                        id="simple-menu"
                                        anchorEl={anchorEl}
                                        keepMounted
                                        open={Boolean(anchorEl)}
                                        onClose={tagHandleClose}
                                    >
                                        <MenuItem onClick={() => tagHandleClose()}
                                            component={Link} to={"/tags-all"}>
                                            タグ一覧
                                        </MenuItem>
                                        <MenuItem onClick={() => tagHandleClose()}
                                            component={Link} to={"/tags-finder"}
                                        >
                                            タグ絞り込み検索
                                        </MenuItem>
                                    </Menu>

                                </Grid>
                                <Grid item>
                                    <Button variant="contained" disableElevation
                                        component={Link} to={"/site-description"}
                                        startIcon={<InfoIcon />}>謎の技術研究部とは</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* ヘッダ ナビゲーション */}

                        {/* スペーシング用 */}

                        <Grid item sx={{
                            flexGrow: 1,
                            [theme.breakpoints.down('lg')]: { display: "none" }
                        }} />

                        {/* 検索インプット 遅延読み込みに変更*/}

                        <Tooltip title="サイト内検索 Powered by Google">
                            <Grid item sx={{
                                [theme.breakpoints.down('lg')]: {
                                    display: 'none',
                                },
                            }}>
                                {/* <React.Suspense fallback={<Box>loading...</Box>}> */}
                                    <ClientOnly>
                                        <Search id="ac14fce807686bac9" />
                                    </ClientOnly>
                                {/* </React.Suspense> */}
                            </Grid>
                        </Tooltip>

                        {/* 検索ここまで */}

                    </Grid>

                </Toolbar>
            </AppBar>

        </Box >
    )
})

export default Header